var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"binds-optgroup"},[_c('binds-subheader',[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }